import { useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import ClipboardIcon from '@mui/icons-material/AssignmentSharp';
import ClipboardSuccessIcon from '@mui/icons-material/AssignmentTurnedInSharp';
import ClipboardErrorIcon from '@mui/icons-material/AssignmentLateSharp';

export default function CopyToClipboardButton({ data }: { data: string }) {
  const [status, setStatus] = useState<'INIT' | 'ERROR' | 'SUCCESS'>('INIT');

  useEffect(() => {
    setStatus('INIT');
  }, [data]);

  function doCopy() {
    navigator.clipboard.writeText(data).then(
      () => setStatus('SUCCESS'),
      () => setStatus('ERROR'),
    );
  }

  switch (status) {
    case 'INIT':
      return (
        <IconButton title="Copy to clipboard" onClick={doCopy}>
          <ClipboardIcon />
        </IconButton>
      );
    case 'ERROR':
      return (
        <IconButton title="Could not copy to clipbaord" onClick={doCopy}>
          <ClipboardErrorIcon />
        </IconButton>
      );
    case 'SUCCESS':
      return (
        <IconButton title="Copied to clipboard" onClick={doCopy}>
          <ClipboardSuccessIcon />
        </IconButton>
      );
  }
}
